import { requestV1, requestV2 } from './base'
import { SamplePost } from './response_types'
import { GetSamplePostResponse } from './door/PostV1'

export const getSamplePosts = async (doorId?: string) => {
  let path = `/me/door/sample_posts`
  if (doorId !== undefined) path += `?door_id=${doorId}`
  return await requestV1<SamplePost[]>('get', path)
}

export const getSamplePost = async (id: number, doorId?: string) => {
  let path = `/me/door/sample_posts/${id}`
  if (doorId !== undefined) path += `?door_id=${doorId}`
  return await requestV1<GetSamplePostResponse>('get', path)
}

export const createSamplePost = async (data: {
  id: string
  character_limit?: number
  door_id?: string
}) => {
  return await requestV1<SamplePost[]>('post', `/me/door/sample_posts`, data)
}

export const updateSamplePost = async (
  sample_post_id: number,
  data: {
    post_dynamo_id: string
    character_limit?: number
    door_id?: string
  }
) => {
  return await requestV1<SamplePost[]>(
    'patch',
    `/me/door/sample_posts/${sample_post_id}`,
    data
  )
}

export const deleteSamplePost = async (post_id: string, doorId?: string) => {
  const data: { [key: string]: string } = {}
  if (doorId !== undefined) data['door_id'] = doorId
  return await requestV1<SamplePost[]>(
    'delete',
    `/me/door/sample_posts/${post_id}`,
    data
  )
}
